import React from 'react';
import { styled } from '@linaria/react';

import { random, normalize } from '@/utils';
import useRandomInterval from '@/hooks/use-random-interval';
import useRequestAnimationFrameLoop from '@/hooks/use-request-animation-frame-loop';

import {
  ENVIRONMENT_WIDTH,
  ENVIRONMENT_HEIGHT,
  FRICTION_MIN,
  FRICTION_MAX,
} from './constants';

const IMG_ROOT = '/images/a-friendly-introduction-to-spring-physics';

const IMAGES = {
  birds: `${IMG_ROOT}/birds.png`,
  cloud1: `${IMG_ROOT}/cloud-1.png`,
  cloud2: `${IMG_ROOT}/cloud-2.png`,
};

const Cloud = ({ initialX, y, baseSpeed, friction, src, width }) => {
  const [x, setX] = React.useState(initialX);

  const basePixelsPerFrame = baseSpeed / 60;
  const effectivePixelsPerFrame = normalize(
    friction,
    FRICTION_MIN,
    FRICTION_MAX,
    baseSpeed * 10,
    baseSpeed
  );

  useRequestAnimationFrameLoop(() => {
    setX((x) => {
      if (x > ENVIRONMENT_WIDTH + 200) {
        return -width;
      }
      return x + effectivePixelsPerFrame;
    });
  });

  return (
    <CloudImg
      src={src}
      style={{
        width,
        transform: `translate(${x}px, ${y}px)`,
      }}
    />
  );
};

const EarthBackground = ({ friction }) => {
  return (
    <Wrapper>
      <Cloud
        friction={friction}
        initialX={ENVIRONMENT_WIDTH * 0.6}
        y={ENVIRONMENT_HEIGHT * 0.35}
        baseSpeed={0.1}
        src={IMAGES.cloud1}
        width={150}
      />
      <Cloud
        friction={friction}
        initialX={ENVIRONMENT_WIDTH * -0.2}
        y={ENVIRONMENT_HEIGHT * 0.7}
        baseSpeed={0.14}
        src={IMAGES.cloud2}
        width={160}
      />
      <Birds src={IMAGES.birds} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: linear-gradient(
    133deg,
    rgba(184, 236, 255, 1) 0%,
    rgba(79, 199, 255, 1) 47%,
    rgba(6, 117, 228, 1) 100%
  );
  overflow: hidden;
`;

const CloudImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  opacity: 0.4;
  will-change: transform;
`;

const Birds = styled.img`
  display: block;
  position: absolute;
  top: 12%;
  left: 2%;
  width: 60px;
`;

export default EarthBackground;
